import React from 'react';
import PropTypes from 'prop-types';
import { usePreviewTablePaginationState, usePreviewTablePageIndexState } from 'store/hooks';
import { getOptions, localizationStrings } from './helper';
import MaterialTable from 'material-table';

const PagedPreviewTable = props => {
  const { isFrequencyTable = false, columns, data, icons = null, editableOptions = null } = props;
  const [pagination, setPagination] = usePreviewTablePaginationState();
  const [pageIndex, setPageIndex] = usePreviewTablePageIndexState();

  const options = getOptions(isFrequencyTable);
  options.pageSize = pagination;
  options.initialPage = pageIndex;

  return (
    <MaterialTable
      icons={icons}
      options={options}
      columns={columns}
      data={data}
      onChangeRowsPerPage={setPagination}
      onChangePage={setPageIndex}
      editable={editableOptions}
      style={{
        display: 'inline-block',
        maxWidth: 'calc(100vw - 320px)',
        overflowX: 'auto'
      }}
      localization={
        localizationStrings
      }
    />
  );
};

PagedPreviewTable.propTypes = {
  isFrequencyTable: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  icons: PropTypes.object,
  editableOptions: PropTypes.object
};

export default PagedPreviewTable;

